export default "__VITE_ASSET__70df0d6f__"